/**
 * Copy for Florida fixed-date tasks. No scheduler imports: the iOS bundle loads this file.
 */

const FLORIDA_TASK_COPY = [
  { title: 'Hurricane season prep', description: 'Get the house ready before hurricane season starts.' },
  { title: 'Hurricane mid-season refresh', description: 'Recheck supplies halfway through hurricane season.' },
  { title: 'AC service before summer', description: 'Service the air conditioner before the hottest months.' },
  { title: 'Homestead exemption reminder', description: "File early so this year's homestead exemption is in place." },
  { title: 'Homestead filing deadline', description: 'The homestead exemption filing window closes on this date.' },
  { title: 'TRIM notice review', description: 'Review the proposed property tax before the hearing window.' },
  { title: 'Property tax early-pay discount', description: 'Paying by this date keeps the largest discount.' },
  { title: 'Property tax discount last chance', description: 'A smaller discount is still available through this date.' },
  { title: 'Property tax final due', description: 'Property tax is due in full on this date.' },
];

function floridaTaskDescription(title) {
  const key = String(title || '').trim().toLowerCase();
  for (let index = 0; index < FLORIDA_TASK_COPY.length; index += 1) {
    if (FLORIDA_TASK_COPY[index].title.toLowerCase() === key) {
      return FLORIDA_TASK_COPY[index].description;
    }
  }
  return '';
}

/**
 * true, false, or null when the home's state is unknown.
 * Unknown homes keep the stored catalog wording.
 */
function isFloridaClient(client) {
  if (!client) return null;
  const explicit = String(client.region_code || '').trim().toUpperCase();
  if (explicit) return explicit === 'US-FL';
  const state = String(client.state || '').trim().toUpperCase();
  if (!state) return null;
  return state === 'FL' || state === 'FLORIDA';
}

const GENERIC_CATALOG_COPY = {
  'review property tax assessment (trim notice)': {
    title: 'Review your property tax assessment',
    description: 'When your property tax assessment arrives, compare the assessed value with similar homes and file an appeal if it looks high.',
  },
};

/** Display copy for a catalog title. Florida homes keep the stored wording. */
function catalogTaskCopy(title, client) {
  if (isFloridaClient(client) !== false) return null;
  const key = String(title || '').trim().toLowerCase();
  return GENERIC_CATALOG_COPY[key] || null;
}

module.exports = {
  FLORIDA_TASK_COPY,
  floridaTaskDescription,
  catalogTaskCopy,
};
